import { CentsPalette } from "../../../../utils/colors";
import { CustomFilledButton } from "../../common/buttons/CustomFilledButton";
import React from "react";
import Loader from "../../common/Loader";

export function FieldSaveButton({ onClick, loading }: { onClick: () => void, loading?: boolean }): JSX.Element {
  return (<CustomFilledButton
    onClick={onClick}
    className="h-10 !w-10 !px-0 focus:outline-none"
    disabled={loading}
  >
    {!loading ? <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 7L9.70711 17.2929C9.31658 17.6834 8.68342 17.6834 8.29289 17.2929L4 13" stroke={CentsPalette.cents_white} strokeWidth="2.5" strokeLinecap="round" />
    </svg> : <Loader />}
  </CustomFilledButton>)
}